import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Phone, Package, CheckCircle2, ArrowRight } from "lucide-react";
import { api, mediaUrl } from "../services/api";
import { formatPrice } from "../utils/formatPrice";
import { useAuth } from "../context/AuthContext";

export default function OrderConfirmation() {
  const { id } = useParams();
  const { user } = useAuth();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get(`/orders/${id}`).then((r) => setOrder(r.data)).catch(() => {});
  }, [id]);

  return (
    <div className="container-queen pt-36 pb-24 max-w-2xl mx-auto text-center" id="main">
      <div className="w-20 h-20 rounded-full bg-[#111111] text-white grid place-items-center mx-auto mb-6 shadow-xl">
        <CheckCircle2 size={40} className="text-[#C5A880]" />
      </div>

      <p className="label-eyebrow text-[#C5A880] mb-2">Confirmation de votre commande</p>
      <h1 className="font-display text-[#111111] text-3xl sm:text-5xl">
        Votre rituel The Queen est en route.
      </h1>

      {order && (
        <p className="font-mono text-[#111111] text-sm mt-3 font-medium bg-[#F8F8F6] inline-block px-4 py-1.5 rounded-full border border-[#EAE8E4]" data-testid="order-number">
          Référence : #{order.order_number}
        </p>
      )}

      <p className="text-[#666666] text-xs sm:text-sm mt-5 max-w-md mx-auto flex items-center justify-center gap-2">
        <Phone size={15} className="text-[#C5A880]" /> 
        Notre équipe vous contactera par téléphone pour confirmer l'expédition.
      </p>

      {order && (
        <div className="bg-white rounded-3xl border border-[#EAE8E4] p-8 mt-10 text-left shadow-sm">
          <div className="flex items-center gap-2.5 mb-6 pb-4 border-b border-[#F8F8F6]">
            <Package size={20} className="text-[#C5A880]" />
            <h2 className="font-display text-xl text-[#111111]">Récapitulatif de votre sélection</h2>
          </div>

          <div className="space-y-4">
            {order.items.map((it, i) => (
              <div key={i} className="flex gap-4 items-center">
                <div className="w-14 h-16 rounded-xl overflow-hidden bg-[#F8F8F6] p-1 shrink-0 border border-[#EAE8E4]">
                  <img src={mediaUrl(it.product_image)} alt={it.product_name} className="w-full h-full object-contain mix-blend-multiply" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-[#111111] line-clamp-1">{it.product_name}</p>
                  <p className="text-xs text-[#888888]">Quantité : {it.quantity}</p>
                </div>
                <span className="text-sm font-semibold text-[#111111]">{formatPrice(it.total_price)}</span>
              </div>
            ))}
          </div>

          <div className="border-t border-[#EAE8E4] mt-6 pt-4 space-y-2 text-xs font-body">
            <div className="flex justify-between text-[#666666]"><span>Sous-total</span><span className="text-[#111111]">{formatPrice(order.subtotal)}</span></div>
            {order.discount_amount > 0 && <div className="flex justify-between text-emerald-700"><span>Privilège</span><span>-{formatPrice(order.discount_amount)}</span></div>}
            <div className="flex justify-between text-[#666666]"><span>Frais de livraison</span><span className="text-[#111111]">{order.delivery_fee === 0 ? "Gratuit" : formatPrice(order.delivery_fee)}</span></div>
            <div className="flex justify-between items-baseline pt-3 border-t border-[#EAE8E4]"><span className="font-display text-lg text-[#111111]">Total dû à la livraison</span><span className="font-body text-xl font-bold text-[#111111]">{formatPrice(order.total)}</span></div>
          </div>

          <div className="mt-6 pt-4 border-t border-[#F8F8F6] text-xs text-[#666666] space-y-1">
            <p><strong className="text-[#111111]">Destinataire :</strong> {order.customer_name} ({order.customer_phone})</p>
            <p><strong className="text-[#111111]">Adresse :</strong> {order.address}, {order.commune ? `${order.commune}, ` : ""}{order.wilaya}</p>
            <p><strong className="text-[#111111]">Règlement :</strong> En espèces au livreur lors de la réception.</p>
          </div>
        </div>
      )}

      <div className="flex flex-col sm:flex-row gap-3 justify-center mt-10">
        <Link to="/shop" className="btn-queen-primary">Continuer vos découvertes <ArrowRight size={15} /></Link>
        {user && <Link to="/orders" className="btn-queen-secondary">Mes commandes</Link>}
      </div>
    </div>
  );
}
